import React from "react";
import Header from "./components/header";
import Sec2 from "./components/section-2";
import Sec3 from "./components/section-3";

export default function LandingPage() {
  return (
    <div className="app-wrapper">
      <Header />
      <Sec2 />
      <Sec3 />
      <style jsx global>{`
        .app-wrapper {
          font-family:  "Poppins", sans-serif !important;
          font-size: 14px;
          --brand-color: #f50057;
          --gray-color-1: #777;
          --gray-color-2: #555;
        }
        a {
          color: inherit;
        }
        a:hover {
          text-decoration: none;
        }
        .jumbo-bg {
          background: transparent;
          background-repeat: no-repeat;
          background-position: center bottom;
          background-size: 100%;
        }
        @media (min-width: 1024px) {
          .jumbo-bg {
            background-attachment: fixed;
          }
        }
      `}</style>
    </div>
  );
}
